import { AnchorHTMLAttributes } from "react";

/**
 * This component is for use in the ReactMarkdown components prop. It will open the link in a new tab.
 * @returns
 */
export default function LinkInNewTab(props: AnchorHTMLAttributes<HTMLAnchorElement>) {
  return (
    <a href={props.href} target="_blank" rel="noopener noreferrer">
      {props.children}
    </a>
  );
}
